import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { CoreExerciseFormInput } from '../types/form';

interface ExerciseFormHookInput {}

interface ExerciseFormHookOutput {
  initialQuestionNumber: number;
  onChangeInitialQuestionNumber: (
    newInitialQuestionNumber: number,
    questionsCount: number,
    onSetValue: (index: number, title: string) => void
  ) => void;
  getDefaultQuestionTitle: (index: number) => string;

  getDefaultExerciseData: (index: number) => CoreExerciseFormInput;
}

export default function useExerciseForm(input: ExerciseFormHookInput = {}): ExerciseFormHookOutput {
  const intl = useIntl();
  const [initialQuestionNumber, setInitialQuestionNumber] = useState(1);

  const getDefaultQuestionTitle = useCallback(
    (index: number): string => {
      return intl.formatMessage({ id: 'defaultQuestionTitle' }, { index: index + initialQuestionNumber });
    },
    [intl, initialQuestionNumber]
  );

  const getDefaultExerciseData = useCallback(
    (index: number): CoreExerciseFormInput => {
      return {
        code: intl.formatMessage({ id: 'defaultExerciseCode' }, { index: index + 1 }),
        forPractice: false,
      };
    },
    [intl]
  );

  const onChangeInitialQuestionNumber = useCallback(
    (newInitialQuestionNumber: number, questionsCount: number, onSetValue: (index: number, title: string) => void) => {
      setInitialQuestionNumber(newInitialQuestionNumber);
      if (initialQuestionNumber !== newInitialQuestionNumber) {
        for (let i = 0; i < questionsCount; i++) {
          onSetValue(i, intl.formatMessage({ id: 'defaultQuestionTitle' }, { index: i + newInitialQuestionNumber }));
        }
      }
    },
    [initialQuestionNumber, intl]
  );

  return {
    initialQuestionNumber,
    onChangeInitialQuestionNumber,

    getDefaultQuestionTitle,

    getDefaultExerciseData,
  };
}
